module.exports = [
  ...require('./_magicItemRawList_DMG_b'),
  require('./bag_of_beans'),
  require('./bag_of_holding'),
  require('./blackrazor'),
  require('./book_of_exalted_deeds'),
  require('./book_of_vile_darkness'),
]
